export const campuses = [
  { id: 'ut-austin', name: 'UT Austin', location: 'Austin, Texas', fullName: 'The University of Texas at Austin', mark: 'UT', primary: '#BF5700', secondary: '#333F48', accent: '#BF5700', soft: '#FFF2E8', foreground: '#FFFFFF', products: ['rent', 'leases'] },
  { id: 'umich', name: 'Michigan', location: 'Ann Arbor, Michigan', fullName: 'University of Michigan', mark: 'M', primary: '#00274C', secondary: '#FFCB05', accent: '#00274C', soft: '#FFF7D9', foreground: '#FFFFFF', products: ['rent'] },
  { id: 'texas-am', name: 'Texas A&M', location: 'College Station, Texas', fullName: 'Texas A&M University', mark: 'A&M', primary: '#500000', secondary: '#2C0000', accent: '#500000', soft: '#F7EEEE', foreground: '#FFFFFF', products: ['rent'] },
];
export const campusById = id => campuses.find(c => c.id === id);
export function resolveRoute(pathname, manifest) {
  const parts = pathname.split('/').filter(Boolean);
  if (!parts.length) return { campus: campuses[0], product: 'rent', home: true };
  if (parts[0] === 'micro-apps') {
    const app = manifest.find(a => a.appId === parts[1] || a.handle === parts[1]);
    return app ? { campus: campusById(app.campus), product: app.product, legacy: true } : null;
  }
  const campus = campusById(parts[0]);
  if (!campus || !campus.products.includes(parts[1]) || parts.length !== 2) return null;
  return { campus, product: parts[1] };
}
